import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    color: 'transparent',
  },
}));

const CellDud = () => {
  const classes = useStyles();

  return <div className={classes.root}>d</div>;
};

export default CellDud;
